import { EFullscreenMode, IUnityInstance } from '../loader';

let fullscreenHandler: (ev: MouseEvent) => void;

const createListener = (instance?: IUnityInstance, fullscreenClass?: string) => {
  if (!instance || !fullscreenClass) {
    return;
  }
  return (ev: MouseEvent) => {
    const button = ev.target as HTMLElement;
    const hasFullscreenClass = button.classList.contains(fullscreenClass);
    if (hasFullscreenClass) {
      // need to remove the focus to prevent exiting the fullscreen on Firefox
      button.blur();
      console.info('### toggle fullscreen to "on" on unity instance ###', EFullscreenMode.On);
      instance.SetFullscreen(EFullscreenMode.On);
    }
  };
};

export function registerFullscreenHandler(instance?: IUnityInstance, fullscreenClass?: string) {
  const handler = createListener(instance, fullscreenClass);
  if (!handler) {
    return;
  }
  fullscreenHandler = handler;
  document.addEventListener('click', fullscreenHandler);
}

export function unregisterFullscreenHandler() {
  if (!fullscreenHandler) {
    return;
  }
  document.removeEventListener('click', fullscreenHandler);
}

export function toggleFullscreenOff(instance: IUnityInstance) {
  if (!instance || !fullscreenHandler) {
    return;
  }
  console.info('### toggle fullscreen to "off" on unity instance ###', EFullscreenMode.Off);
  instance.SetFullscreen(EFullscreenMode.Off);
}
